import { render, staticRenderFns } from "./AllTaskDetail.vue?vue&type=template&id=1194d249&scoped=true&"
import script from "./AllTaskDetail.vue?vue&type=script&lang=js&"
export * from "./AllTaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./AllTaskDetail.vue?vue&type=style&index=0&id=1194d249&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1194d249",
  null
  
)

export default component.exports